import "./style.scss";

export function specialists_hero_block() {
  const block = document.querySelector(".specialists_hero_block");
  if (!block) return;
}
